import { createUseStyles } from 'react-jss'

export default createUseStyles({
  customLabels: {
    margin: '0 -0.3rem -0.6rem',
  },
})
